import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__string_pattern } from '@shared/dto/generation/graph_invoke/_enums/ENUM__string_pattern';
import { assert_not_equal, assert_true } from './utils_asserts';

export function assert_string_uuid(value: string): asserts value is string {
  let [source, flags] = ENUM__string_pattern.UUID;

  let pattern = new RegExp(source, flags);

  assert_true(pattern.test(value));
}

export function assert_string_uuid_not_empty(value: string): string {
  assert_string_uuid(value);

  assert_not_equal(value, ENUM__string_id_empty.UUID);

  return value;
}
